export function showProductSelectorDialogHandler(state) {
  state.showProductSelectorDialog = true
}
export function setProducts(state, products) {
  state.products = products;
}
